import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import * as companyService from "services/company-service";

interface IProps {
    open: boolean;
    onClose: () => void;
    refresh: () => void;
    selectedCompanies: Company[];
    tenantId?: string;
}

const MergeCompaniesModal = (props: IProps) => {
    const { open, onClose, selectedCompanies, refresh, tenantId } = props;
    const { t } = useTranslation();
    const [selectedCompany, setSelectedCompany] = useState<Company | undefined>(
        undefined,
    );

    const handleCreate = (): void => {
        if (selectedCompany === undefined) {
            // show validation error
            return;
        }

        const mergedCompanyIds = selectedCompanies
            .filter((c) => c.id !== selectedCompany.id)
            .map((company) => company.id);

        companyService
            .mergeCompanies(selectedCompany.id, mergedCompanyIds, tenantId)
            .then(() => {
                // show success message
                refresh();
                handleClose();
            });
    };

    const handleClose = (): void => {
        setSelectedCompany(undefined);
        onClose();
    };

    const handleSelectedCompany = (
        event: React.ChangeEvent<HTMLInputElement>,
        value: string,
    ): void => {
        selectedCompanies.find((company) => company.id === value) &&
            setSelectedCompany(
                selectedCompanies.find((company) => company.id === value),
            );
    };

    return (
        <Dialog open={open} fullWidth maxWidth={"sm"}>
            <DialogTitle>{t("company.merge.title")}</DialogTitle>
            <DialogContent>
                <Box>
                    <p>{t("company.merge.description")}</p>
                    <FormControl>
                        <RadioGroup
                            value={selectedCompany?.id}
                            onChange={handleSelectedCompany}
                        >
                            {open &&
                                selectedCompanies.map((company: Company) => (
                                    <FormControlLabel
                                        control={<Radio />}
                                        key={company.id}
                                        value={company.id}
                                        label={company.name}
                                    />
                                ))}
                        </RadioGroup>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClose}
                >
                    {t("company.create.cancel")}
                </Button>
                <Button
                    disabled={selectedCompany === undefined}
                    variant="contained"
                    color="success"
                    onClick={handleCreate}
                >
                    {t("company.merge.merge")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MergeCompaniesModal;
